import moment from 'moment'
export const headerData = [
    { headerName: 'User Log Report Date', value: moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY, HH:mm:ss') },
    { headerName: 'MTMM', value: moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY, HH:mm:ss') },
    { headerName: 'Report For', value: 'KRI (KRISHNA-FRANCHISEE-MNT)' },
    { headerName: 'Corporation', value: 'All' },
    { headerName: 'Area', value: 'Mantralaya' },
    { headerName: 'Counter Code', value: 'KRIKRI' },

]
export const columnDefs = [
    { headerName: 'S.No.', headerNameV2: 'S.No.', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "4.23%" }, showFilter: true },
    { headerName: `Cancelled\nDate`, headerNameV2: "Cancelled Date", field: 'Canceldate', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "6.77%" }, showFilter: true },
    { headerName: `Ticket No.`, headerNameV2: "OB Reference ID", field: 'OBRefNo', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "9.32%" }, showFilter: true },
    { headerName: `Date of\nJourney`, headerNameV2: "Date of Journe", field: 'JourneyDate', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "7.2%" }, showFilter: true },
    { headerName: `Cancel\nPNR`, headerNameV2: "Cancel PNR", field: 'CancelPnr', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "8.47%" }, showFilter: true },
    { headerName: `Refund\nAmount`, headerNameV2: "Refund Amount", field: 'RefundAmount', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "4.23%" }, showFilter: true },
    { headerName: `No. of\nSeats`, headerNameV2: "No. of Seats", field: 'Seatcount', xlCol: { dataType: 'number', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'right', minCellWidth: "4.23%" }, showFilter: true },
    { headerName: `From\nPlace`, headerNameV2: "From Place", field: 'FromCityName', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "5.93%" }, showFilter: true },
    { headerName: `To\nPlace`, headerNameV2: "To Place", field: 'ToCityName', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "4.23%" }, showFilter: true },
    { headerName: 'Type', headerNameV2: "Type", field: 'Type', xlCol: { dataType: 'string', dataFormatter: null, width: 25, height: 20 }, headerSx: { textAlign: 'left', minCellWidth: "4.23%" }, showFilter: true },

]
export const calculateDynamicFormatLandscape = (desiredWidth) => {
    // Standard A4 landscape aspect ratio: width / height = 297 / 210
    const a4LandscapeAspectRatio = 1122 / 793;

    // Calculate the height based on the aspect ratio
    const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

    return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
    // Standard A4 Portrait aspect ratio: width / height = 297 / 210
    const a4LandscapeAspectRatio = 793 / 1122;

    // Calculate the height based on the aspect ratio
    const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);
    return [desiredWidth, dynamicHeight];
};
export function calculateTotalTableWidth(columnDefs) {
    let totalWidth = 0;
    columnDefs.forEach(column => {
        totalWidth += parseInt(column.headerSx.minCellWidth);
    });
    return totalWidth;
}